import { NgModule } from '@angular/core';
import { QueuesManagementNavigationMenuComponent } from './';
import { QueuingSystemSharedModule } from '../../../../shared';
import { NavigationMenuModule } from '../../../generic/navigation-menu';
import { FacultyNavigationMenuElementComponent } from './faculty-navigation-menu-element';
import { QueueNavigationMenuElementComponent } from './queue-navigation-menu-element';

@NgModule({
    imports: [
        QueuingSystemSharedModule,
        NavigationMenuModule
    ],
    declarations: [
        FacultyNavigationMenuElementComponent,
        QueueNavigationMenuElementComponent,
        QueuesManagementNavigationMenuComponent
    ],
    exports: [QueuesManagementNavigationMenuComponent]
})
export class QueuesManagementNavigationMenuModule {
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/management-navigation-menu/queues-management-navigation-menu/queues-management-navigation-menu.module.ts